<template>
	<div class="slideshow">
		<div class="anchor" :style="{paddingBottom: height + '%'}">
			<div class="container" :style="{left: containerOffset}">
				<slot></slot>
			</div>

			<div class="control" v-if="!hideControls">
				<div class="side">
					<div class="arrow left" @click="prev"></div>
					<div class="arrow right" @click="next"></div>
				</div>

				<div class="bottom">
					<span v-for="(n, i) in numSlides" :key="i" class="circle" :class="currentSlide == i ? 'selected' : ''"
						@click="set(i)"></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'slideshow',

	props: {
		numSlides: {
			type: Number,
			required: true
		},
		ratio: {
			type: Number,
			default: 16.0 / 9.0
		},
		autoplay: {
			type: Number,
			default: 5000
		},
		hideControls: {
			type: Boolean,
			default: false
		}
	},

	data() {

		return {
			/// Index of current slide
			currentSlide: 0,
			/// Autoplay timer
			autoplayTimer: null
		}
	},

	computed: {
		/**
		 * 
		 */
		containerOffset() {

			return (-this.currentSlide * 100) + '%'
		},

		/**
		 * 
		 */
		height() {

			return (1.0 / this.ratio) * 100
		}
	},

	methods: {
		/**
		 * 
		 */
		set(i) {

			while (i < 0) i += this.numSlides
			while (i >= this.numSlides) i -= this.numSlides
			this.currentSlide = i

			if (this.autoplayTimer)
			{
				clearTimeout(this.autoplayTimer)
				this.autoplayTimer = null
			}

			if (this.autoplay)
			{
				this.autoplayTimer = setTimeout(() => {
					this.next()
				}, this.autoplay)
			}
		},

		/**
		 * 
		 */
		next() {

			this.set(this.currentSlide + 1)
		},

		/**
		 * 
		 */
		prev() {

			this.set(this.currentSlide - 1)
		}
	},

	mounted() {

		this.set(0)
	}
}
</script>

<style lang="stylus" scoped>
.anchor
	width 100%

	position relative

	padding-bottom 100%

	overflow-x hidden

.container
	width 100%
	height 100%

	display flex
	flex-wrap nowrap

	position absolute
	top 0
	left 0
	z-index 1

	transition left 0.5s ease

	&>*
		flex 0 0 auto

.control
	width 100%
	height 100%

	position absolute
	top 0
	left 0
	z-index 2

	pointer-events none

	.side
		height 100%

		display flex
		justify-content space-between

		.arrow
			height 100%

			display flex
			align-items center

			pointer-events auto
			cursor pointer

			&:before
				display inline-block
				padding 0.6em

				font-family 'Material Icons'
				font-size 4em
				font-weight bold
			&.left:before
				content 'keyboard_arrow_left'
			&.right:before
				content 'keyboard_arrow_right'
	
	.bottom
		width 100%
		height 57px

		display flex
		justify-content center
		align-items flex-end

		position absolute
		bottom 0

		padding 0.5em
		box-sizing border-box

		background-color rgba(dark, 0.2)

		.circle
			width 1em
			height 1em

			display inline-block

			margin 0.6em 0.4em
			border-radius 2em

			background-color light

			pointer-events auto
			cursor pointer

			transition height 0.2s ease

			&.selected
				height 1.6em
</style>